import React, { useState, useEffect } from 'react';
import { apiService } from '../../components/Config/api.service';
import { notify } from '../../components/Utils/Notifications';
import { FiEdit2, FiTrash2, FiCheck, FiX, FiPlus, FiLoader } from 'react-icons/fi';

function DepartmentManager({ departments = [], setDepartments, setDepartmentOptions, onClose, showColumn = true, setShowColumn }) {
    const [list, setList] = useState(departments || []);
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [editingName, setEditingName] = useState('');

    useEffect(() => setList(departments || []), [departments]);

    const refresh = async () => {
        try {
            const res = await apiService.getElement('/employee/departments');
            const depts = res.data.departments || [];
            setList(depts);
            if (setDepartments) setDepartments(depts);
            if (setDepartmentOptions) setDepartmentOptions(depts.map(d => ({ value: d.id, label: d.name })));
        } catch (e) { /* ignore */ }
    };

    useEffect(() => { refresh(); }, []);

    const handleCreate = async () => {
        const name = input.trim();
        if (!name) return;
        setLoading(true);
        try {
            const res = await apiService.saveElement('/employee/department', { name });
            const newDept = res.data.result || res.data;
            const added = newDept || { id: newDept.id, name: newDept.name };
            await refresh();
            setInput('');
            notify('Département créé', '', 2);
        } catch (e) {
            notify('Erreur lors de la création', '', 3);
        } finally {
            setLoading(false);
        }
    };

    const startEdit = (d) => {
        setEditingId(d.id);
        setEditingName(d.name || '');
    };

    const saveEdit = async (id) => {
        if (!editingName.trim()) return;
        setLoading(true);
        try {
            await apiService.updateElementById('/employee/department', id, { name: editingName });
            await refresh();
            setEditingId(null);
            notify('Département modifié', '', 2);
        } catch {
            notify('Erreur lors de la modification', '', 3);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Supprimer ce département ?')) return;
        setLoading(true);
        try {
            await apiService.updateElementById('/employee/delete-department', id, {});
            await refresh();
            notify('Département supprimé', '', 2);
        } catch {
            notify('Erreur lors de la suppression', '', 3);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold">Gérer les départements</h3>
                <div className="flex items-center gap-2">
                    <label className="label cursor-pointer">
                        <span className="label-text mr-2 text-sm">Afficher colonne</span>
                        <input
                            type="checkbox"
                            className="toggle toggle-sm checked:bg-[--color-orange]"
                            checked={showColumn}
                            onChange={e => setShowColumn && setShowColumn(e.target.checked)}
                            aria-label="Afficher la colonne département"
                        />
                    </label>
                    {/* <button className="btn btn-xs btn-outline" onClick={onClose}>Fermer</button> */}
                </div>
            </div>

            <div className="flex gap-2 mb-4">
                <input
                    className="input input-sm input-bordered flex-1"
                    placeholder="Ajouter un département"
                    value={input}
                    onChange={e => setInput(e.target.value)}
                />
                <button className="btn btn-sm btn-primary" onClick={handleCreate} disabled={loading || !input.trim()}>
                    {loading ? <FiLoader className="animate-spin" /> : <FiPlus />} Ajouter
                </button>
            </div>

            <ul className="divide-y">
                {list.length === 0 && <li className="py-4 text-center text-gray-400">Aucun département.</li>}
                {list.map(d => (
                    <li key={d.id} className="flex items-center py-2">
                        {editingId === d.id ? (
                            <>
                                <input className="input input-sm input-bordered flex-1 mr-2" value={editingName} onChange={e => setEditingName(e.target.value)} />
                                <button className="btn btn-xs btn-success mr-1" onClick={() => saveEdit(d.id)}><FiCheck /></button>
                                <button className="btn btn-xs btn-outline" onClick={() => setEditingId(null)}><FiX /></button>
                            </>
                        ) : (
                            <>
                                <span className="flex-1">{d.name}</span>
                                <button className="btn btn-xs btn-outline mr-1" onClick={() => startEdit(d)}><FiEdit2 /></button>
                                <button className="btn btn-xs btn-error" onClick={() => handleDelete(d.id)}><FiTrash2 /></button>
                            </>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default DepartmentManager;